let language = {
ADD_STORE_PRODUCT_MODAL_SETECT_STORE_TITLE:"将产品添加到商店",
ADD_STORE_PRODUCT_MODAL_SETECT_STORE_CANCEL_BTN:"取消",
ADD_STORE_PRODUCT_MODAL_SETECT_STORE_NEXT_BTN:"下一个"
};

export { language }